import { Project } from '@/app/network/models/project';
import { BackLink } from '@/common/components/back-link';
import { Currency } from '@/common/components/currency';
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '@/common/components/description-list';
import { DisplayValue } from '@/common/components/display-value';
import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { DeleteProject } from '@/projects/components/delete-project';
import { UpdateProject } from '@/projects/components/update-project';

type ShowProjectPageProps = {
  projectId: number;
  project: Project;
};

export function ShowProjectPage({ projectId, project }: ShowProjectPageProps) {
  return (
    <>
      <Seo title={project.name} />
      <BackLink href="/projects">
        Projects
      </BackLink>
      <div className="flex items-center justify-between gap-4 mt-4">
        <div className="flex items-center gap-4">
          <Heading>{project.name}</Heading>
        </div>
        <div className="flex gap-4">
          <UpdateProject project={project} />
        </div>
      </div>

      <div className="mt-8">
        <DescriptionList>
          <DescriptionTerm>Client</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue value={project.client?.name} />
          </DescriptionDetails>

          <DescriptionTerm>Budget</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue
              value={project.budget}
              renderer={budget => <Currency value={budget} />}
            />
          </DescriptionDetails>

          <DescriptionTerm>Rate</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue
              value={project.rate}
              renderer={rate => <Currency value={rate} />}
            />
          </DescriptionDetails>

          <DescriptionTerm>Billing Type</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue
              value={project.billingType}
              renderer={(billingType) => {
                const billingTypeMap = {
                  hourly: 'Hourly',
                  fixedCost: 'Fixed Cost',
                  retainer: 'Retainer',
                  proBono: 'Pro Bono'
                };
                return billingTypeMap[billingType] || billingType;
              }}
            />
          </DescriptionDetails>

          <DescriptionTerm>Start Date</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue
              value={project.startOn}
              renderer={date => date ? new Date(date).toLocaleDateString() : ''}
            />
          </DescriptionDetails>

          <DescriptionTerm>End Date</DescriptionTerm>
          <DescriptionDetails>
            <DisplayValue
              value={project.endOn}
              renderer={date => date ? new Date(date).toLocaleDateString() : ''}
            />
          </DescriptionDetails>

          <DescriptionTerm>Danger Zone</DescriptionTerm>
          <DescriptionDetails>
            <DeleteProject projectId={projectId} />
          </DescriptionDetails>
        </DescriptionList>
      </div>
    </>
  );
}
